import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";

const HorizontalBarChart = (props) => {
  const [height, setHeight] = useState(315);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2133) {
        setHeight(360);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(315);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(280);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(246);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(205);
      } else {
        setHeight(315);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const margin = {
    top: height * 0.015,
    right: height * 0.003,
    bottom: height * 0,
    left: height * 0.45,
  };

  return (
    <BarChart
      skipAnimation={false}
      height={height * 0.9}
      borderRadius={4}
      layout="horizontal"
      bottomAxis={{
        disableTicks: true,
        disableLine: true,
        tickLabelStyle: {
          display: "none",
        },
      }}
      leftAxis={{
        disableTicks: true,
        disableLine: true,
        tickLabelStyle: {
          fontSize: "0.625em",
          fontWeight: "700",
          display: "none",
        },
      }}
      sx={{
        [`.css-nsbw82-MuiChartsLegend-root`]: {
          display: "none",
        },
        [`.MuiChartsLegend-root MuiChartsLegend-row css-1xdhyk6`]: {
          display: "none",
        },
        [`.MuiChartsLegend-row`]: {
          display: "none",
        },
        [`.MuiChartsLegend-root`]: {
          display: "none",
        },
      }}
      slotProps={{
        // barLabel: {
        //   style: { fill: "white", fontSize: "1.25em", fontWeight: "700" },
        // },
        // legend: {
        //   direction: "row",
        //   position: { vertical: "bottom", horizontal: "left" },
        //   padding: -1,
        //   labelStyle: {
        //     fontSize: height / 30,
        //     fontWeight: "600",
        //     fill: "black",
        //   },
        // },
        legend: null,
      }}
      grid={{ vertical: true, horizontal: true }}
      margin={margin}
      tooltip={{ trigger: "item" }}
      {...props}
    />
  );
};

export default HorizontalBarChart;
